import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cs from 'classnames';
import styles from './styles';

const useStyles = makeStyles(styles);

export const Field = ({ label, emph, children }) => {
  const classes = useStyles();

  return (
    <span>
      {label && <span className={classes.label}>{label} </span>}
      <span className={emph ? classes.emph : classes.value}>{children}</span>
    </span>
  );
};

// Poppins digits are proportional, so a fixed-width fraction keeps the decimal points in line
export const Hours = ({ value }) => {
  const classes = useStyles();
  const [whole, fraction] = value.split('.');

  return (
    <span className={classes.hours}>
      {whole}
      <span className={classes.fraction}>.{fraction}</span>
      hours
    </span>
  );
};

// label and hours are pinned to row 1, columns 3-4; children fill the columns before them
export const Total = ({ hours, label, children }) => {
  const classes = useStyles();

  return (
    <div className={classes.grid}>
      {children}
      {label && <span className={classes.totalLabel}>{label}</span>}
      <Hours value={hours} />
    </div>
  );
};

export const WeekSummary = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={cs(classes.block, classes.week)}>
      <div className={classes.weekTitle}>Week Summary</div>
      <div className={classes.weekSum}>{children}</div>
    </div>
  );
};
